export default function () {
  const widgetName = 'multiScheduleFeature';
  const widgetOpts = multiScheduleFeatureOpts;

  $(`#${widgetName}`).append('<div class="multiFeatureContent"></div>');

  $(`#${widgetName}`).MultiScheduleFeature({
    scriptPath: widgetOpts.scriptPath
    , currentWidgetModuleItemID: widgetOpts.WidgetModuleDataItemID
    , detectIpad: IPADDETECTED
    , isResponsive: false
    // options
    , allEventsLink: true
    , allEventsLinkText: 'view ALL EVENTS'
    , hasImages: false
    , imageBackground: false
    , lazyLoadImages: true
    , buyNowButton: { visible: false, text: 'BUY NOW' }
    , moreButton: { visible: false, text: 'MORE' }
    , maxItemsVisible: 5
    , hasDescription: true
    , textContainer: true
    , link: 'all' 
    , attributeOrder: {
      1: 'image',
      2: 'title',
      3: 'date',
      4: 'description',
      5: 'buttons'
    }
    , multiFeatureLoaded: function (data) {

      let eventsNumber = data.length;

      $('#multiScheduleFeature').prepend('<div class="events-title"><h2>Upcoming Events</h2></div>');
      $(`#${widgetName} .featureItem`).each(function (i) {

        const itemDescripton = $(this).find('.featureItemDescription');
        const eventDate = $(this).find('.featureItemDate');
        formatDate(eventDate);
        itemDescripton.text(setCharLimit(itemDescripton, 100));
        $(this).find('.featureItemTitle, .featureItemDescription').wrapAll('<div class="event-data-wrap"></div>');

        if (data[i].URL == "") {
          $(this).append('<span class="arrow-empty"></span>');
          $(this).removeAttr('href');
          $(this).addClass('void');
        } else {
          $(this).append('<span class="arrow"></span>');
        }
        $('.all-events-btn').addClass('button');
      });

      $(document).ready(function () {
        if (eventsNumber < 1) {
          $('#mainFeatureSlideShow .event-container').remove();
        }
      })

      $('#multiScheduleFeature').appendTo('#mainFeatureSlideShow .event-container .inner-container');

    }

  });
};

function setCharLimit(el, limit) {
  const text = el.text();
  return text.length > limit ? `${text.substring(0, limit)}...` : text;
}

function formatDate(el) {
  const datesMonth = el.text().slice(0, 3);
  const datesDay = el.text().slice(4, 7).replace(',', '');
  el.html(`${datesMonth}<span>${datesDay}</span>`);
}